'use client';

import { preload } from 'react-dom';

import { optimizedImageAttributes } from '../../util/optimizedImage';
import { S } from './Hero.styles';
import type { HeroProps } from './Hero.types';

// Breite der Hauptspalte: Layout-Padding 32px je Seite, ab lg 8/12 und ab xl 7/12 des Rasters.
const HERO_SIZES =
  '(min-width: 1440px) calc((100vw - 64px) * 7 / 12), (min-width: 1024px) calc((100vw - 64px) * 2 / 3), calc(100vw - 64px)';

export const Hero = ({ children, imageSrc, imageAlt, ...otherProps }: HeroProps) => {
  // Das Hero-Bild ist das LCP-Element. Das HTML der Uebersicht ist mehrere hundert KB gross, der
  // <img> kommt spaet im Stream; ein Preload im <head> startet den Download direkt nach dem TTFB.
  if (imageSrc) {
    const { src, srcSet, sizes } = optimizedImageAttributes(imageSrc, HERO_SIZES);
    preload(src, { as: 'image', fetchPriority: 'high', ...(srcSet && { imageSrcSet: srcSet, imageSizes: sizes }) });
  }

  return (
    <S.Container {...otherProps} $hasTitle={!!children} data-guide-id="hero-container">
      <S.Image src={imageSrc} alt={imageAlt || ''} sizes={HERO_SIZES} fetchPriority="high" data-guide-id="hero-image" />
      {children && (
        <S.Content data-guide-id="hero-image-content">
          <S.Title data-guide-id="hero-image-content-title">{children}</S.Title>
        </S.Content>
      )}
    </S.Container>
  );
};
